import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProjectConstants } from "src/app/project-constants";
import { urls } from "src/services/api/urls";
import { GeneralServicesImplService } from "src/services/general-services-impl.service";
import * as servers from '../../../../services/api/servers';

@Injectable({
    providedIn: 'root'
  })

  export class BillingUploadService extends GeneralServicesImplService{
      constructor(http: HttpClient){
          super(http);
      }

    //   baseUrl: string = servers.apiUrl + urls.consuntivoVolumiController;
    baseUrl: string = servers.apiUrl + urls.billingController;
    form = new FormData();
    uploadBilling(file: FormData, numAnnoMese: number, providerCod: string, status: string): Observable<any> {
        // const url = this.baseUrl + this.LINKS.UPLOAD_BILLING
        //                          + '/' + numAnnoMese.toString()
        //                          + '/' + providerCod
        //                          + '/' + status;
        const url = this.baseUrl + this.LINKS.UPLOAD_BILLING;
        const body =  file;
        body.append("numAnnoMese", numAnnoMese.toString());
        body.append("providerCod", providerCod);
        const header = ProjectConstants.returnHeaderBlank();
        return this.http.post( url, body, {headers: header, responseType: 'json'})
          .pipe(
            // map (data => data) da inserire gestione errori
          );
      }
  }